module.exports = __webpack_public_path__ + "static/53gde-8bef7e362a2b99296b41a5f964f70cab.gif";